import { h } from 'preact'
import CoreScroll from '@nrk/core-scroll'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import { BaseElement } from '@nrk/dh-server-libs/base-element'

import './app.module.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

class AppElement extends BaseElement {
  name = tag

  render() {
    this.sendGaEvent({ eventAction: `MOUNT:${tag}` })
    this.initCoreScroll()
  }

  findClosestProgramEntry(container: HTMLElement): HTMLElement {
    // no scroll container
    if (container == null) {
      return
    }

    const today = container.querySelector<HTMLElement>('[data-today]')
    // events haven't started or last event was yesterday
    if (today == null) {
      return
    }

    const events = today.querySelectorAll<HTMLDivElement>('[data-timestamp]')
    if (events.length === 0) {
      return today
    }

    const now = new Date()
    const closestEvent = Array.from(events)
      .reverse()
      .find((el) => now > new Date(el.dataset.timestamp))

    return closestEvent ?? today
  }

  async initCoreScroll() {
    const scrollElement: HTMLElement = this.querySelector('.dh-sportsbanner-scroll')
    const scrollTarget: HTMLElement = this.findClosestProgramEntry(scrollElement)

    if (scrollTarget) {
      if (document.fonts?.ready) {
        await document.fonts.ready
      }

      // core-scroll overrides Element.scroll(), so we bypass that
      Element.prototype.scroll.call(scrollElement, {
        left: scrollTarget.offsetLeft,
        behavior: 'auto',
      } as ScrollToOptions)
    }
  }
}

safeDefine('dh-sportsbanner-core-scroll', CoreScroll)
safeDefine(tag, AppElement)
